<template>
    <b-container>
      <b-row>
        <b-col cols="8">
          <b-row>
        <div style="height: 600px; width: 100%">
<!--            <div style="overflow: auto; height: 20px;">-->
    <!--            <p>Последнее местоположение: {{ withPopup.lat }}, {{ withPopup.lng }}</p>-->
    <!--            <p>Center is at {{ currentCenter }} and the zoom is: {{ currentZoom }}</p>-->
    <!--            <button @click="showLongText">-->
    <!--                Toggle long popup-->
    <!--            </button>-->
    <!--            <button @click="showMap = !showMap">-->
    <!--                Toggle map-->
    <!--            </button>-->
<!--            </div>-->
            <l-map
                v-if="visible"
                :zoom="zoom"
                :center="center"
                :options="mapOptions"
                style="height: 99%"
                @update:center="centerUpdate"
                @update:zoom="zoomUpdate"
                ref="map"
            >
                <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                />
                <l-marker :lat-lng="withPopup">
                    <l-popup>
                        <div @click="innerClick">
    <!--                        I am a popup-->
    <!--                        <p v-show="showParagraph">-->
    <!--                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque-->
    <!--                            sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.-->
    <!--                            Donec finibus semper metus id malesuada.-->
    <!--                        </p>-->
                        </div>
                    </l-popup>
                </l-marker>
    <!--            <l-marker :lat-lng="withTooltip">-->
    <!--                <l-tooltip :options="{ permanent: true, interactive: true }">-->
    <!--                    <div @click="innerClick">-->
    <!--&lt;!&ndash;                        I am a tooltip&ndash;&gt;-->
    <!--&lt;!&ndash;                        <p v-show="showParagraph">&ndash;&gt;-->
    <!--&lt;!&ndash;                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque&ndash;&gt;-->
    <!--&lt;!&ndash;                            sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.&ndash;&gt;-->
    <!--&lt;!&ndash;                            Donec finibus semper metus id malesuada.&ndash;&gt;-->
    <!--&lt;!&ndash;                        </p>&ndash;&gt;-->
    <!--                    </div>-->
    <!--                </l-tooltip>-->
    <!--            </l-marker>-->
            </l-map>
        </div>
          </b-row>
        </b-col>
        <b-col>
            <b-row>
              <b-col>
                <b-row>
                <b-col>IMEI: </b-col>
                <b-col>{{imei}}</b-col>
                </b-row>
              </b-col>
            </b-row>
              <hr/>
            <b-row>
              <b-col>
<!--                <b-card-header>{{$t('maps.device.common')}}</b-card-header>-->
                <!--          <b-row>-->
                <!--            <b-col>{{ $t('maps.device.common.status') }}:</b-col>-->
                <!--            <b-col>{{deviceData.status}}</b-col>-->
                <!--          </b-row>-->
                <b-row>
                  <b-col>{{ $t('maps.device.common.last_date') }}:</b-col>
                  <b-col>{{deviceData.lastDate}}</b-col>
                </b-row>
                <b-row>
                  <b-col>{{ $t('maps.device.common.moving_sensor') }}:</b-col>
                  <b-col>{{deviceStatus.mw}}</b-col>
                </b-row>
                <b-row>
                  <b-col>{{ $t('maps.device.navigation.speed') }}:</b-col>
                  <b-col>{{navigation.speed}} {{ $t('unit.speed') }}</b-col>
                </b-row>
                <b-row>
                  <b-col>{{ $t('maps.device.navigation.satellites') }}:</b-col>
                  <b-col>{{navigation.satellites}}</b-col>
                </b-row>
              </b-col>
            </b-row>
          <hr />
            <b-row>
              <b-col>
<!--                <b-card-header>{{$t('maps.device.navigation')}}</b-card-header>-->

                <b-row>
                  <b-col>{{ $t('maps.device.common.internal_voltage') }}:</b-col>
                  <b-col>{{voltage.internal}} {{ $t('unit.voltage') }}</b-col>
                </b-row>
                <b-row>
                  <b-col>{{ $t('maps.device.common.external_voltage') }}:</b-col>
                  <b-col>{{voltage.external}} {{ $t('unit.voltage') }}</b-col>
                </b-row>
                <b-row>
                  <b-col>{{ $t('maps.device.inputs_outputs.pin0') }}:</b-col>
                  <b-col v-if="deviceStatus.in0">{{$t('unit.on')}}</b-col>
                  <b-col v-else>{{$t('unit.off')}}</b-col>
                </b-row>
                <b-row>
                  <b-col>{{ $t('maps.device.inputs_outputs.pin1') }}:</b-col>
                  <b-col v-if="deviceStatus.in1">{{$t('unit.on')}}</b-col>
                  <b-col v-else>{{$t('unit.off')}}</b-col>
                </b-row>
                <b-row>
                  <b-col>{{ $t('maps.device.inputs_outputs.pin2') }}:</b-col>
                  <b-col v-if="deviceStatus.in2">{{$t('unit.on')}}</b-col>
                  <b-col v-else>{{$t('unit.off')}}</b-col>
                </b-row>
<!--                <b-row>-->
<!--                  <b-col>{{ $t('maps.device.navigation.latitude') }}:</b-col>-->
<!--                  <b-col>{{navigation.latitude}}</b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col>{{ $t('maps.device.navigation.longitude') }}:</b-col>-->
<!--                  <b-col>{{navigation.longitude}}</b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col>{{ $t('maps.device.navigation.height') }}:</b-col>-->
<!--                  <b-col>{{navigation.height}}</b-col>-->
<!--                </b-row>-->
<!--                <b-row>-->
<!--                  <b-col>{{ $t('maps.device.navigation.course') }}:</b-col>-->
<!--                  <b-col>{{navigation.course}}</b-col>-->
<!--                </b-row>-->
              </b-col>
            </b-row>
            <hr/>
            <b-row>
              <b-col>
<!--              <b-card-header>{{$t('maps.device.sensors')}}</b-card-header>-->
              <b-row>
                <b-col>{{ $t('maps.device.sensors.iccid1') }}:</b-col>
                <b-col v-if="iccid1.value != null">{{iccid1.value}}</b-col>
                <b-col v-else>{{$t('unit.empty')}}</b-col>
              </b-row>
              <b-row>
                <b-col>{{ $t('maps.device.sensors.iccid2') }}:</b-col>
                <b-col v-if="iccid2.value != null">{{iccid2.value}}</b-col>
                <b-col v-else>{{$t('unit.empty')}}</b-col>
              </b-row>
              <b-row>
                <b-col>{{ $t('maps.device.sensors.hwStatus') }}:</b-col>
                <b-col>{{hardwareStatus.value}}</b-col>
              </b-row>
            </b-col>
            </b-row>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import { latLng } from "leaflet";
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    // LTooltip
} from "vue2-leaflet";
import { Icon } from 'leaflet';
import axios from "axios";


delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    name: "DeviceSettingsMap",
    props: {
        id: {
            type: Number
        },
        imei: {
            type: String
        },
        visible: {
            type: Boolean
        }
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        // LTooltip
    },
    data() {
        return {
            zoom: 13,
            center: latLng(55.7537, 37.619813),
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: "",
            withPopup: latLng(55.7537, 37.619813),
            // withTooltip: latLng(55.7537, 37.619813),
            currentZoom: 11.5,
            currentCenter: latLng(55.7537, 37.619813),
            showParagraph: false,
            mapOptions: {
                // zoomSnap: 0.5
            },
            showMap: false,
            updateAvailable: true,
            deviceData: {
              status: null,
              date: null,
              external: null,
              internal: null,
              moveSensor: null,
              lastDate: null
            },
          voltage: {
              date: null,
              external: null,
              internal: null,
            },
            navigation: {
                latitude: null,
                longitude: null,
                speed: null,
                satellites: null,
                height: null,
                course: null,
            },
            inputs: {
                pin0: null,
                pin1: null,
                pin2: null,
            },
            sensors: {
                iccid1: null,
                iccid2: null,
                hwStatus: null
            },
            iccid1: {
              value: null,
              date: null
            },
            iccid2: {
              value: null,
              date: null
            },
            hardwareStatus: {
              value: null,
              date: null
            },
            deviceStatus: {
              in0: null,
              in1: null,
              in2: null,
              in3: null,
              in4: null,
              in5: null,
              in6: null,
              in7: null,
              out0: null,
              out1: null,
              out2: null,
              out3: null,
              gsmSt: null,
              navSt: null,
              mw: null,
              simT: null,
              simIn: null,
              st0: null,
              st1: null,
              st2: null,
              pwrIn: null,
              pwrExt: null,
              date: null
            }
        };
    },
    methods: {
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            // alert(111)
            this.currentCenter = center;
            // console.log('map was moved')
        },
        showLongText() {
            this.showParagraph = !this.showParagraph;
        },
        innerClick() {
            alert("Click!");
        },
        setCenter(center) {
            const mapComponent = this.$refs.map;
            mapComponent.setCenter(center)
        },
        update() {
            if (this.updateAvailable) {
                axios
                    .get('api/v1/devices/' + this.id + '/coordinates')
                    .then((data) => {
                        // console.log(data)
                      this.deviceData.lastDate = data.data.lastDate;

                      const coordinates = data.data.coordinates;

                      if (coordinates !== null) {
                        this.withPopup = latLng(coordinates.latitude, coordinates.longitude)
                        this.center = latLng(coordinates.latitude, coordinates.longitude)

                        this.navigation.latitude = coordinates.latitude;
                        this.navigation.longitude = coordinates.longitude;
                        this.navigation.height = coordinates.height;
                        this.navigation.course = coordinates.course;

                        this.navigation.satellites = 0;
                        if (!isNaN(Number.parseInt(coordinates.gpsSatellites))) {
                          this.navigation.satellites += Number.parseInt(coordinates.gpsSatellites)
                        }
                        if (!isNaN(Number.parseInt(coordinates.glonassSatellites))) {
                          this.navigation.satellites +=Number.parseInt(coordinates.glonassSatellites);
                        }

                        this.navigation.speed = (Math.round(coordinates.speed * 100) / 100).toFixed(2);
                      }
                      const voltage = data.data.voltage;
                      if (voltage !== null) {
                        this.voltage.date = voltage.date;
                        this.voltage.external = (Math.round(voltage.externalVoltage * 100) / 100).toFixed(2);
                        this.voltage.internal = (Math.round(voltage.internalVoltage * 100) / 100).toFixed(2);
                      }
                      const iccid1 = data.data.iccid1;
                      if (iccid1 !== null) {
                        this.iccid1.value = iccid1.value;
                        this.iccid1.date = iccid1.date;
                      }
                      const iccid2 = data.data.iccid2;
                      if (iccid2 !== null) {
                        this.iccid2.value = iccid2.value;
                        this.iccid2.date = iccid2.date;
                      }
                      const hardwareStatus = data.data.hardwareStatus;
                      if (hardwareStatus !== null) {
                        this.hardwareStatus.value = hardwareStatus.value;
                        this.hardwareStatus.date = hardwareStatus.date;
                      }
                      const deviceStatus = data.data.deviceStatus;
                      if (deviceStatus !== null) {
                        this.deviceStatus = deviceStatus
                      }

                      const inputs = data.data.inputs;

                      if (inputs !== null) {
                        // console.log(1);
                      }
                      const sensors = data.data.sensors;

                      if (sensors !== null) {
                        // console.log(1);
                      }
                    })
                    .catch(() => {
                        this.updateAvailable = false;

                    });
            }
        },
    },
    mounted() {
        // const mapComponent = this.$refs.map;
        // // this.showMap = false
        // // console.log(mapComponent)
        //
        // mapComponent.mapObject.on('move', () => {
        //     this.centerLatLong = this.$refs.map.mapObject.getCenter()
        //     console.log('map was moved')
        //     console.log(this.centerLatLong)
        // })
        this.update();
    },
    created() {
        this.timer = setInterval(this.update, 30000)
    },
    beforeDestroy() {
        clearInterval(this.timer)
    }
};
</script>
